const shapes = [
  'Tila',
  'Seed Bead',
  'Various',
];

export default shapes;
